// extracted by mini-css-extract-plugin
module.exports = {"overAll":"dndboardscreen_overAll__2UWIa","statusFlex":"dndboardscreen_statusFlex__2e4t_"};